var render = function render(){var _vm=this,_c=_vm._self._c;return _c('question',_vm._g(_vm._b({attrs:{"question":_vm.question,"operates":_vm.operates,"type":_vm.isSpecial ? 'view' : 'edit'}},'question',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }